import { Check } from 'lucide-react'

import { cn } from '@/lib/cn'

export interface SelectCheckboxProps {
  checked: boolean
  /** Names the row, e.g. `Select Blue Monday`. */
  label: string
  /** `shiftKey` is true when the user meant "everything up to here". */
  onChange: (shiftKey: boolean) => void
  className?: string
}

/**
 * A row tick box.
 *
 * A button rather than an `<input>`: it sits beside a full-row play button, and
 * a native checkbox would need a label element wrapping content that is already
 * inside another control.
 */
export function SelectCheckbox({ checked, label, onChange, className }: SelectCheckboxProps) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={label}
      onClick={(event) => onChange(event.shiftKey)}
      className={cn(
        'flex h-11 w-11 shrink-0 select-none items-center justify-center rounded-lg transition-colors hover:bg-surface-hover',
        className,
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          'flex h-5 w-5 items-center justify-center rounded-md border transition-colors',
          checked ? 'border-accent bg-accent text-on-accent' : 'border-border-strong',
        )}
      >
        {checked ? <Check className="h-3.5 w-3.5" /> : null}
      </span>
    </button>
  )
}
